import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Input } from '@/shared/components/Input';
import { Button } from '@/shared/components/Button';
import { ApiError } from '@/lib/api-client';
import { useUpdateStudent } from '../hooks/useStudents';
/**
 * Edits the basic data fields of a student. Email and DNI are not editable
 * (the backend update schema explicitly omits them — they require dedicated
 * flows that aren't implemented yet). Opposition / shift / status have their
 * own modals.
 */
export function EditStudentDataForm({ student, onSuccess }) {
    const [serverError, setServerError] = useState(null);
    const updateStudent = useUpdateStudent(student.id);
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            student_number: student.student_number ?? undefined,
            first_name: student.first_name,
            last_name: student.last_name,
            phone: student.phone ?? '',
            address: student.address ?? '',
            birth_date: student.birth_date ?? '',
            start_date: student.start_date ?? '',
        },
    });
    function onSubmit(values) {
        setServerError(null);
        const dto = {
            first_name: values.first_name.trim(),
            last_name: values.last_name.trim(),
            phone: values.phone.trim() || undefined,
            address: values.address.trim() || undefined,
            birth_date: values.birth_date || undefined,
            start_date: values.start_date || undefined,
        };
        if (values.student_number !== undefined && !Number.isNaN(values.student_number)) {
            dto['student_number'] = values.student_number;
        }
        updateStudent.mutate(dto, {
            onSuccess: () => onSuccess(),
            onError: (err) => {
                setServerError(err instanceof ApiError ? err.message : 'Ha ocurrido un error.');
            },
        });
    }
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), className: "flex flex-col gap-4", noValidate: true, children: [_jsx(Input, { label: "N\u00FAmero de alumno", type: "number", min: 1, error: errors.student_number?.message, ...register('student_number', {
                    valueAsNumber: true,
                    min: { value: 1, message: 'Debe ser un entero positivo' },
                }) }), _jsxs("div", { className: "grid gap-4 sm:grid-cols-2", children: [_jsx(Input, { label: "Nombre", error: errors.first_name?.message, ...register('first_name', { required: 'El nombre es obligatorio' }) }), _jsx(Input, { label: "Apellidos", error: errors.last_name?.message, ...register('last_name', { required: 'Los apellidos son obligatorios' }) })] }), _jsx(Input, { label: "Email", type: "email", value: student.email, disabled: true, hint: "El email no se puede modificar desde aqu\u00ED.", readOnly: true }), _jsx(Input, { label: "DNI", value: student.dni, disabled: true, hint: "El DNI no se puede modificar desde aqu\u00ED.", readOnly: true }), _jsx(Input, { label: "Tel\u00E9fono", type: "tel", placeholder: "612345678", error: errors.phone?.message, ...register('phone', {
                    pattern: {
                        value: /^[6789]\d{8}$|^$/,
                        message: 'El teléfono debe ser español (9 dígitos, empieza por 6/7/8/9)',
                    },
                }) }), _jsx(Input, { label: "Direcci\u00F3n", ...register('address') }), _jsx(Input, { label: "Fecha de nacimiento", type: "date", ...register('birth_date') }), _jsx(Input, { label: "Fecha de inicio", type: "date", hint: "Hasta esta fecha el alumno no aparece al pasar lista ni se le generan mensualidades.", ...register('start_date') }), serverError && (_jsx("p", { role: "alert", className: "text-sm text-red-600 dark:text-red-400", children: serverError })), _jsx(Button, { type: "submit", loading: updateStudent.isPending, className: "w-full", children: "Guardar cambios" })] }));
}
//# sourceMappingURL=EditStudentDataForm.js.map